import axiosClient from "api/apiClient";

export const APIPostFeedback = (data: object) => {
    return axiosClient.post(`/feedback`, data, {
            headers: {
                'Content-Type': 'multipart/form-data', // Axios should handle this automatically
            },
        }
    );
  };